(function () {
  'use strict';

  if (window.FormwynnSetEventLoaded) return;
  window.FormwynnSetEventLoaded = true;

  var core = window.FormwynnSetEventCore;
  var previouslyFocused = null;
  var activeDrawer = null;
  var activeCard = null;
  var selectedVariants = { bra: null, bottom: null };
  var activeCustomDrawer = null;
  var customPreviouslyFocused = null;
  var customSelectedVariants = { bra: null, bottom: null };
  var priorQualification = null;
  var qualificationSource = 'cart_state';
  var qualificationTracked = false;
  var cartRefreshPromise = null;
  var cartRefreshQueued = false;

  function all(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function one(selector, root) {
    return (root || document).querySelector(selector);
  }

  function activityStatus() {
    var source = one('[data-set-event-section]') || one('[data-set-event-qualified]');
    return source ? source.dataset.activityStatus || 'active' : 'active';
  }

  function campaignContext() {
    var query = new URLSearchParams(window.location.search);
    return {
      page_path: window.location.pathname,
      activity_status: activityStatus(),
      utm_source: query.get('utm_source') || '',
      utm_campaign: query.get('utm_campaign') || '',
    };
  }

  function track(eventName, detail) {
    if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.analyticsProcessingAllowed === 'function') {
      if (!window.Shopify.customerPrivacy.analyticsProcessingAllowed()) return;
    }
    var payload = Object.assign({ event: eventName }, campaignContext(), detail || {});
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    document.dispatchEvent(new CustomEvent('formwynn:' + eventName, { detail: payload }));
  }

  function parseProduct(card, selector) {
    var node = one(selector, card);
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return null;
    }
  }

  function statusNode() {
    return activeDrawer && one('[data-set-event-status]', activeDrawer);
  }

  function showStatus(message) {
    var node = statusNode();
    if (node) node.textContent = message || '';
  }

  function renderChoices(container, choices, role) {
    container.innerHTML = '';
    selectedVariants[role] = null;

    choices.forEach(function (choice) {
      var button = document.createElement('button');
      button.type = 'button';
      button.textContent = choice.size;
      button.dataset.variantId = String(choice.id);
      button.dataset.setEventSizeRole = role;
      button.setAttribute('aria-pressed', 'false');
      if (!choice.available) {
        button.disabled = true;
        button.setAttribute('aria-label', choice.size + ' — sold out');
      } else {
        button.setAttribute('aria-label', 'Select size ' + choice.size);
      }

      if (choice.autoSelected && choice.available) {
        button.setAttribute('aria-pressed', 'true');
        selectedVariants[role] = choice.id;
      }

      container.appendChild(button);
    });
  }

  function updateAddButton() {
    var addButton = activeDrawer && one('[data-set-event-add]', activeDrawer);
    if (!addButton) return;
    addButton.disabled = !(selectedVariants.bra && selectedVariants.bottom) || addButton.dataset.loading === 'true';
  }

  function focusableElements(drawer) {
    return all('button:not([disabled]):not([tabindex="-1"]), [href]:not([tabindex="-1"]), input:not([disabled]):not([tabindex="-1"]), select:not([disabled]):not([tabindex="-1"]), textarea:not([disabled]):not([tabindex="-1"]), [tabindex]:not([tabindex="-1"])', drawer)
      .filter(function (element) { return !element.hidden && element.offsetParent !== null; });
  }

  function trapDrawerFocus(event) {
    var currentDrawer = activeCustomDrawer || activeDrawer;
    if (!currentDrawer || event.key !== 'Tab') return;
    var focusable = focusableElements(currentDrawer);
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (focusable.indexOf(document.activeElement) === -1) {
      event.preventDefault();
      (event.shiftKey ? last : first).focus();
      return;
    }
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function closeDrawer() {
    if (!activeDrawer) return;
    var loadingButton = one('[data-set-event-add]', activeDrawer);
    if (loadingButton && loadingButton.dataset.loading === 'true') return;
    activeDrawer.setAttribute('aria-hidden', 'true');
    activeDrawer.hidden = true;
    document.body.classList.remove('set-event-drawer-open');
    document.removeEventListener('keydown', onDrawerKeydown);
    if (previouslyFocused && typeof previouslyFocused.focus === 'function') previouslyFocused.focus();
    activeDrawer = null;
    activeCard = null;
    selectedVariants = { bra: null, bottom: null };
  }

  function prepareCartDrawer(cartDrawer, returnFocus) {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-empty');
    if (returnFocus && typeof cartDrawer.setActiveElement === 'function') {
      cartDrawer.setActiveElement(returnFocus);
    }
  }

  function syncCartDrawerEmptyState(cartDrawer) {
    if (!cartDrawer) return;
    var drawerInner = one('.drawer__inner', cartDrawer);
    cartDrawer.classList.toggle('is-empty', Boolean(drawerInner && drawerInner.classList.contains('is-empty')));
  }

  async function refreshCartDrawer() {
    if (cartRefreshPromise) {
      cartRefreshQueued = true;
      return cartRefreshPromise;
    }
    var cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer || typeof cartDrawer.renderContents !== 'function') return null;
    var cartUrl = window.routes && window.routes.cart_url
      ? window.routes.cart_url
      : ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart';
    // /cart negotiates to cart JSON with Accept: application/json, not section HTML.
    var sectionRoot = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/');

    cartRefreshPromise = fetch(sectionRoot + '?sections=cart-drawer,cart-icon-bubble', {
      headers: { Accept: 'application/json' },
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to refresh the bag.');
        return response.json();
      })
      .then(function (sections) {
        prepareCartDrawer(cartDrawer, document.activeElement);
        cartDrawer.renderContents({ id: null, sections: sections });
        syncCartDrawerEmptyState(cartDrawer);
        return sections;
      })
      .catch(function () {
        window.location.assign(cartUrl);
        return null;
      })
      .finally(function () {
        cartRefreshPromise = null;
        if (cartRefreshQueued) {
          cartRefreshQueued = false;
          refreshCartDrawer();
        }
      });

    return cartRefreshPromise;
  }

  function onDrawerKeydown(event) {
    if (event.key === 'Escape') {
      event.preventDefault();
      if (activeCustomDrawer) closeCustomDrawer(); else closeDrawer();
      return;
    }
    trapDrawerFocus(event);
  }

  function setText(selector, value) {
    var node = activeDrawer && one(selector, activeDrawer);
    if (node) node.textContent = value || '';
  }

  function productMedia(product, colour) {
    if (!product) return { url: '', image: '', alt: '' };
    var image = '';
    var colourIndex = core ? core.findOptionIndex(product.options || [], ['color', 'colour']) : -1;
    var colourKey = core ? core.normalizeValue(colour || '') : String(colour || '').trim().toLowerCase();
    var variants = product.variants || [];

    for (var index = 0; index < variants.length; index += 1) {
      var variant = variants[index];
      var variantColour = colourIndex >= 0 ? String((variant.options || [])[colourIndex] || '') : '';
      var variantColourKey = core ? core.normalizeValue(variantColour) : variantColour.trim().toLowerCase();
      if ((!colourKey || colourIndex < 0 || variantColourKey === colourKey) && variant.image) {
        image = variant.image;
        break;
      }
    }

    if (!image) image = product.featured_image || '';
    return {
      url: product.url || '',
      image: image,
      alt: product.title + (colour ? ' — ' + colour : ''),
    };
  }

  function setProductLinks(drawer, prefix, role, product, variantId) {
    if (!drawer || !product) return;
    var baseUrl = product.url || '';
    var destination = baseUrl;
    if (baseUrl && variantId) destination += (baseUrl.indexOf('?') === -1 ? '?' : '&') + 'variant=' + variantId;
    all('[data-' + prefix + '-' + role + '-link], [data-' + prefix + '-' + role + '-link-title]', drawer).forEach(function (link) {
      if (destination) link.href = destination; else link.removeAttribute('href');
    });
  }

  function syncProductMedia(drawer, prefix, role, product, colour) {
    if (!drawer) return;
    var media = productMedia(product, colour);
    var wrapper = one('[data-' + prefix + '-' + role + '-media]', drawer);
    var image = one('[data-' + prefix + '-' + role + '-image]', drawer);
    var titleLink = one('[data-' + prefix + '-' + role + '-link-title]', drawer);
    if (titleLink) titleLink.textContent = product && product.title ? product.title : '';
    setProductLinks(drawer, prefix, role, product, null);
    if (image) {
      if (media.image) {
        image.src = media.image;
        image.alt = media.alt;
        image.hidden = false;
      } else {
        image.removeAttribute('src');
        image.alt = '';
        image.hidden = true;
      }
    }
    if (wrapper) wrapper.hidden = !media.image;
  }

  function syncDrawerProductMedia(drawer, role, product, colour) {
    syncProductMedia(drawer, 'set-event', role, product, colour);
  }

  function syncCustomProductMedia(drawer, role, product, colour) {
    syncProductMedia(drawer, 'custom', role, product, colour);
  }

  function openDrawer(card, trigger) {
    core = window.FormwynnSetEventCore;
    var section = card.closest('[data-set-event-section]');
    var drawer = section && one('[data-set-event-drawer]', section);
    if (!core || !drawer) return;

    var bra = parseProduct(card, '[data-set-event-bra-json]');
    var bottom = parseProduct(card, '[data-set-event-bottom-json]');
    var braChoices = core.buildVariantChoices(bra, card.dataset.braColour);
    var bottomChoices = core.buildVariantChoices(bottom, card.dataset.bottomColour);

    activeDrawer = drawer;
    activeCard = card;
    previouslyFocused = trigger;
    selectedVariants = { bra: null, bottom: null };
    drawer._formwynnProducts = { bra: bra, bottom: bottom };

    var addButton = one('[data-set-event-add]', drawer);
    if (addButton) {
      addButton.dataset.loading = 'false';
      addButton.textContent = 'ADD BOTH TO BAG';
    }

    setText('[data-set-event-title]', card.dataset.setName);
    setText('[data-set-event-bra-title]', card.dataset.braTitle);
    setText('[data-set-event-bra-colour]', card.dataset.braColour || 'Default');
    setText('[data-set-event-bottom-title]', card.dataset.bottomTitle);
    setText('[data-set-event-bottom-colour]', card.dataset.bottomColour || 'Default');
    syncDrawerProductMedia(drawer, 'bra', bra, card.dataset.braColour);
    syncDrawerProductMedia(drawer, 'bottom', bottom, card.dataset.bottomColour);

    renderChoices(one('[data-set-event-bra-sizes]', drawer), braChoices, 'bra');
    renderChoices(one('[data-set-event-bottom-sizes]', drawer), bottomChoices, 'bottom');
    setProductLinks(drawer, 'set-event', 'bra', bra, selectedVariants.bra);
    setProductLinks(drawer, 'set-event', 'bottom', bottom, selectedVariants.bottom);
    if (!braChoices.length || !bottomChoices.length) {
      showStatus('This set is unavailable because its configured colour or variant structure could not be matched.');
    } else {
      showStatus('Choose a bra size and a bottom size.');
    }
    updateAddButton();

    drawer.hidden = false;
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('set-event-drawer-open');
    document.addEventListener('keydown', onDrawerKeydown);
    window.requestAnimationFrame(function () {
      var closeButton = one('[data-set-event-close]:not([tabindex="-1"])', drawer);
      if (closeButton) closeButton.focus();
    });

    track('build_set_click', {
      set_name: card.dataset.setName,
      bra_product: card.dataset.braTitle,
      bottom_product: card.dataset.bottomTitle,
      bra_colour: card.dataset.braColour,
      bottom_colour: card.dataset.bottomColour,
    });
  }

  async function addSet() {
    var addButton = activeDrawer && one('[data-set-event-add]', activeDrawer);
    if (!addButton || !activeCard || !selectedVariants.bra || !selectedVariants.bottom) return;

    addButton.dataset.loading = 'true';
    addButton.disabled = true;
    addButton.textContent = 'ADDING…';
    showStatus('Adding both pieces to your bag…');

    var submission = {
      setSlug: activeCard.dataset.setSlug,
      setName: activeCard.dataset.setName,
      braProductId: activeCard.dataset.braProductId,
      braVariantId: selectedVariants.bra,
      bottomProductId: activeCard.dataset.bottomProductId,
      bottomVariantId: selectedVariants.bottom,
    };

    try {
      var payload = window.FormwynnSetEventCore.createAddPayload(
        { slug: submission.setSlug },
        submission.braVariantId,
        submission.bottomVariantId,
        window.location.pathname,
      );
      var addUrl = window.routes && window.routes.cart_add_url
        ? window.routes.cart_add_url
        : ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart/add.js';
      var response = await fetch(addUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(payload),
      });
      var result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'Unable to add both pieces.');

      qualificationSource = 'set_builder';
      track('set_add_to_cart', {
        set_name: submission.setName,
        bra_product_id: submission.braProductId,
        bra_variant_id: submission.braVariantId,
        bottom_product_id: submission.bottomProductId,
        bottom_variant_id: submission.bottomVariantId,
      });

      var cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && result.sections && typeof cartDrawer.renderContents === 'function') {
        prepareCartDrawer(cartDrawer, previouslyFocused);
        addButton.dataset.loading = 'false';
        addButton.textContent = 'ADD BOTH TO BAG';
        closeDrawer();
        try {
          cartDrawer.renderContents(result);
          syncCartDrawerEmptyState(cartDrawer);
        } catch (renderError) {
          console.error('Unable to refresh the bag display after a successful add.', renderError);
          window.location.assign((window.routes && window.routes.cart_url) || '/cart');
        }
      } else {
        window.location.assign((window.routes && window.routes.cart_url) || '/cart');
      }
    } catch (error) {
      showStatus(error && error.message ? error.message : 'Something went wrong. Please try again.');
      addButton.dataset.loading = 'false';
      addButton.textContent = 'ADD BOTH TO BAG';
      updateAddButton();
    }
  }

  function deviceType() {
    return window.matchMedia && window.matchMedia('(max-width: 749px)').matches ? 'mobile' : 'desktop';
  }

  function customStatus(message) {
    var node = activeCustomDrawer && one('[data-custom-set-status]', activeCustomDrawer);
    if (node) node.textContent = message || '';
  }

  function customProductMap(section) {
    if (section._formwynnCustomProducts) return section._formwynnCustomProducts;
    var map = { bra: Object.create(null), bottom: Object.create(null) };
    all('[data-custom-product-json]', section).forEach(function (node) {
      try {
        var product = JSON.parse(node.textContent);
        var role = node.dataset.productRole;
        if (map[role] && product && product.handle) map[role][product.handle] = product;
      } catch (error) {
        return;
      }
    });
    section._formwynnCustomProducts = map;
    return map;
  }

  function productColours(product) {
    if (!core || !product) return [];
    var colourIndex = core.findOptionIndex(product.options, ['color', 'colour']);
    if (colourIndex < 0) return product.has_only_default_variant ? ['Default'] : [];
    var seen = Object.create(null);
    return product.variants.reduce(function (values, variant) {
      var value = String((variant.options || [])[colourIndex] || '').trim();
      var key = core.normalizeValue(value);
      if (value && !seen[key]) {
        seen[key] = true;
        values.push(value);
      }
      return values;
    }, []);
  }

  function renderCustomChoices(container, choices, role) {
    container.innerHTML = '';
    customSelectedVariants[role] = null;
    choices.forEach(function (choice) {
      var button = document.createElement('button');
      button.type = 'button';
      button.textContent = choice.size;
      button.dataset.variantId = String(choice.id);
      button.dataset.customSizeRole = role;
      button.setAttribute('aria-pressed', 'false');
      if (!choice.available) {
        button.disabled = true;
        button.setAttribute('aria-label', choice.size + ' — sold out');
      } else {
        button.setAttribute('aria-label', 'Select ' + role + ' size ' + choice.size);
      }
      if (choice.autoSelected && choice.available) {
        button.setAttribute('aria-pressed', 'true');
        customSelectedVariants[role] = choice.id;
      }
      container.appendChild(button);
    });
  }

  function updateCustomAddButton() {
    var addButton = activeCustomDrawer && one('[data-custom-set-add]', activeCustomDrawer);
    if (!addButton) return;
    addButton.disabled = !(customSelectedVariants.bra && customSelectedVariants.bottom) || addButton.dataset.loading === 'true';
  }

  function syncCustomRole(section, role, preserveColour) {
    var drawer = activeCustomDrawer || one('[data-custom-set-drawer]', section);
    var products = customProductMap(section);
    var productSelect = one(role === 'bra' ? '[data-custom-bra-product]' : '[data-custom-bottom-product]', drawer);
    var colourSelect = one(role === 'bra' ? '[data-custom-bra-colour]' : '[data-custom-bottom-colour]', drawer);
    var sizeContainer = one(role === 'bra' ? '[data-custom-bra-sizes]' : '[data-custom-bottom-sizes]', drawer);
    if (!productSelect || !colourSelect || !sizeContainer) return;
    var product = products[role][productSelect.value];
    var priorColour = preserveColour ? colourSelect.value : '';
    colourSelect.innerHTML = '';
    productColours(product).forEach(function (colour) {
      var option = document.createElement('option');
      option.value = colour === 'Default' ? '' : colour;
      option.textContent = colour;
      colourSelect.appendChild(option);
    });
    if (priorColour && all('option', colourSelect).some(function (option) { return option.value === priorColour; })) {
      colourSelect.value = priorColour;
    }
    var choices = core.buildVariantChoices(product, colourSelect.value);
    renderCustomChoices(sizeContainer, choices, role);
    section._formwynnCustomSelection = section._formwynnCustomSelection || {};
    section._formwynnCustomSelection[role] = { product: product, colour: colourSelect.value };
    syncCustomProductMedia(drawer, role, product, colourSelect.value);
    setProductLinks(drawer, 'custom', role, product, customSelectedVariants[role]);
    customStatus(choices.length ? 'Choose a bra size and a bottom size.' : 'This product configuration is unavailable.');
    updateCustomAddButton();
  }

  function closeCustomDrawer() {
    if (!activeCustomDrawer) return;
    var addButton = one('[data-custom-set-add]', activeCustomDrawer);
    if (addButton && addButton.dataset.loading === 'true') return;
    activeCustomDrawer.hidden = true;
    activeCustomDrawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('set-event-drawer-open');
    document.removeEventListener('keydown', onDrawerKeydown);
    if (customPreviouslyFocused && typeof customPreviouslyFocused.focus === 'function') customPreviouslyFocused.focus();
    activeCustomDrawer = null;
    customSelectedVariants = { bra: null, bottom: null };
  }

  function openCustomDrawer(section, trigger) {
    core = window.FormwynnSetEventCore;
    var drawer = one('[data-custom-set-drawer]', section);
    if (!core || !drawer) return;
    activeCustomDrawer = drawer;
    customPreviouslyFocused = trigger;
    customSelectedVariants = { bra: null, bottom: null };
    var addButton = one('[data-custom-set-add]', drawer);
    if (addButton) {
      addButton.dataset.loading = 'false';
      addButton.textContent = 'ADD BOTH TO BAG';
    }
    syncCustomRole(section, 'bra', false);
    syncCustomRole(section, 'bottom', false);
    drawer.hidden = false;
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('set-event-drawer-open');
    document.addEventListener('keydown', onDrawerKeydown);
    window.requestAnimationFrame(function () {
      var closeButton = one('[data-custom-set-close]:not([tabindex="-1"])', drawer);
      if (closeButton) closeButton.focus();
    });
    track('build_your_own_open', { device_type: deviceType(), activity_status: activityStatus() });
  }

  async function addCustomSet(section) {
    var addButton = activeCustomDrawer && one('[data-custom-set-add]', activeCustomDrawer);
    var selection = section._formwynnCustomSelection || {};
    if (!addButton || !selection.bra || !selection.bottom || !customSelectedVariants.bra || !customSelectedVariants.bottom) return;
    addButton.dataset.loading = 'true';
    addButton.disabled = true;
    addButton.textContent = 'ADDING…';
    customStatus('Adding both pieces to your bag…');
    var submission = {
      bra: selection.bra,
      bottom: selection.bottom,
      braVariantId: customSelectedVariants.bra,
      bottomVariantId: customSelectedVariants.bottom,
    };
    try {
      var payload = window.FormwynnSetEventCore.createAddPayload(
        { slug: 'custom-stayform-set' },
        submission.braVariantId,
        submission.bottomVariantId,
        window.location.pathname,
      );
      var addUrl = window.routes && window.routes.cart_add_url
        ? window.routes.cart_add_url
        : ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart/add.js';
      var response = await fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload),
      });
      var result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'Unable to add both pieces.');
      qualificationSource = 'set_builder';
      var tracking = {
        bra_product_id: submission.bra.product.id,
        bra_variant_id: submission.braVariantId,
        bottom_product_id: submission.bottom.product.id,
        bottom_variant_id: submission.bottomVariantId,
        bra_colour: submission.bra.colour,
        bottom_colour: submission.bottom.colour,
      };
      track('custom_set_add_to_cart', tracking);
      track('set_add_to_cart', Object.assign({ set_name: 'Build Your Own' }, tracking));
      var cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && result.sections && typeof cartDrawer.renderContents === 'function') {
        prepareCartDrawer(cartDrawer, customPreviouslyFocused);
        addButton.dataset.loading = 'false';
        addButton.textContent = 'ADD BOTH TO BAG';
        closeCustomDrawer();
        try {
          cartDrawer.renderContents(result);
          syncCartDrawerEmptyState(cartDrawer);
        } catch (renderError) {
          window.location.assign((window.routes && window.routes.cart_url) || '/cart');
        }
      } else {
        window.location.assign((window.routes && window.routes.cart_url) || '/cart');
      }
    } catch (error) {
      customStatus(error && error.message ? error.message : 'Something went wrong. Please try again.');
      addButton.dataset.loading = 'false';
      addButton.textContent = 'ADD BOTH TO BAG';
      updateCustomAddButton();
    }
  }

  function initSection(section) {
    if (section.dataset.setEventBound === 'true') return;
    section.dataset.setEventBound = 'true';

    all('[data-set-event-open]', section).forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        openDrawer(trigger.closest('[data-set-event-card]'), trigger);
      });
    });
    all('[data-set-event-close]', section).forEach(function (button) {
      button.addEventListener('click', closeDrawer);
    });
    section.addEventListener('click', function (event) {
      var button = event.target.closest('[data-set-event-size-role]');
      if (!button || button.disabled || !section.contains(button)) return;
      var role = button.dataset.setEventSizeRole;
      if (role !== 'bra' && role !== 'bottom') return;
      var container = button.parentElement;
      all('button', container).forEach(function (other) {
        other.setAttribute('aria-pressed', other === button ? 'true' : 'false');
      });
      selectedVariants[role] = Number(button.dataset.variantId);
      if (activeDrawer && activeDrawer._formwynnProducts) {
        setProductLinks(activeDrawer, 'set-event', role, activeDrawer._formwynnProducts[role], selectedVariants[role]);
      }
      showStatus('');
      updateAddButton();
    });
    var addButton = one('[data-set-event-add]', section);
    if (addButton) addButton.addEventListener('click', addSet);

    var featuredGrid = one('[data-featured-sets]', section);
    var featuredToggle = one('[data-featured-sets-toggle]', section);
    if (featuredGrid && featuredToggle) {
      featuredToggle.addEventListener('click', function () {
        var isExpanded = featuredGrid.classList.toggle('is-expanded');
        var total = all('[data-featured-index]', featuredGrid).length;
        var defaultVisible = deviceType() === 'mobile' ? 3 : 4;
        featuredToggle.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
        featuredToggle.textContent = isExpanded ? 'SHOW FEWER SETS' : 'VIEW ALL FEATURED SETS';
        var liveStatus = one('[data-featured-sets-status]', section);
        if (liveStatus) {
          liveStatus.textContent = isExpanded
            ? 'Showing all ' + total + ' featured sets.'
            : 'Showing ' + Math.min(defaultVisible, total) + ' featured sets.';
        }
        track('featured_sets_expand', {
          expanded: isExpanded,
          visible_before: isExpanded ? Math.min(defaultVisible, total) : total,
          visible_after: isExpanded ? total : Math.min(defaultVisible, total),
          device_type: deviceType(),
        });
      });
    }

    var moreIdeas = one('[data-more-set-ideas]', section);
    if (moreIdeas) {
      moreIdeas.addEventListener('toggle', function () {
        if (!moreIdeas.open) return;
        track('more_set_ideas_open', {
          entry_location: 'stayform_set_event',
          activity_status: activityStatus(),
        });
      });
    }

    var customOpen = one('[data-build-your-own-open]', section);
    if (customOpen) {
      customOpen.addEventListener('click', function () { openCustomDrawer(section, customOpen); });
    }
    all('[data-custom-set-close]', section).forEach(function (button) {
      button.addEventListener('click', closeCustomDrawer);
    });

    var braProduct = one('[data-custom-bra-product]', section);
    var bottomProduct = one('[data-custom-bottom-product]', section);
    var braColour = one('[data-custom-bra-colour]', section);
    var bottomColour = one('[data-custom-bottom-colour]', section);
    if (braProduct) braProduct.addEventListener('change', function () { syncCustomRole(section, 'bra', false); });
    if (bottomProduct) bottomProduct.addEventListener('change', function () { syncCustomRole(section, 'bottom', false); });
    if (braColour) braColour.addEventListener('change', function () { syncCustomRole(section, 'bra', true); });
    if (bottomColour) bottomColour.addEventListener('change', function () { syncCustomRole(section, 'bottom', true); });

    section.addEventListener('click', function (event) {
      var button = event.target.closest('[data-custom-size-role]');
      if (!button || button.disabled || !section.contains(button)) return;
      var role = button.dataset.customSizeRole;
      if (role !== 'bra' && role !== 'bottom') return;
      all('button', button.parentElement).forEach(function (other) {
        other.setAttribute('aria-pressed', other === button ? 'true' : 'false');
      });
      customSelectedVariants[role] = Number(button.dataset.variantId);
      var customSelection = section._formwynnCustomSelection && section._formwynnCustomSelection[role];
      if (activeCustomDrawer && customSelection) {
        setProductLinks(activeCustomDrawer, 'custom', role, customSelection.product, customSelectedVariants[role]);
      }
      customStatus('');
      updateCustomAddButton();
    });
    var customAddButton = one('[data-custom-set-add]', section);
    if (customAddButton) customAddButton.addEventListener('click', function () { addCustomSet(section); });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        track('set_gallery_view');
        observer.disconnect();
      }, { threshold: 0.15 });
      observer.observe(one('[data-set-event-gallery]', section) || section);
    } else {
      track('set_gallery_view');
    }
  }

  function readQualification() {
    var node = one('[data-set-event-qualified]');
    if (!node) return null;
    return node.dataset.setEventQualified === 'true';
  }

  function checkQualificationTransition() {
    var current = readQualification();
    if (current === null) return;
    if (priorQualification === null) {
      priorQualification = current;
      qualificationTracked = current;
      return;
    }
    if (!priorQualification && current && !qualificationTracked) {
      track('towel_qualified', { qualification_source: qualificationSource });
      qualificationTracked = true;
    }
    if (current) qualificationSource = 'cart_state';
    priorQualification = current;
  }

  function initQualificationObserver() {
    if (document.documentElement.dataset.setEventQualificationBound === 'true') return;
    document.documentElement.dataset.setEventQualificationBound = 'true';
    checkQualificationTransition();
    new MutationObserver(checkQualificationTransition).observe(document.body, { childList: true, subtree: true });
  }

  function init(root) {
    all('[data-set-event-section]', root || document).forEach(initSection);
    initQualificationObserver();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('cart:refresh', refreshCartDrawer);
})();
